function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagSquareRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "150px",
    height: "100px",
    viewBox: "0 0 150 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 0 L 150 0 L 150 50 L 0 50 Z M 0 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(83.529413%,16.862746%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 0 50 L 150 50 L 150 100 L 0 100 Z M 0 50 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,22.352941%,65.098041%)",
      fillOpacity: 1
    },
    d: "M 0 33.332031 L 150 33.332031 L 150 66.667969 L 0 66.667969 Z M 0 33.332031 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSquareRu);
export default __webpack_public_path__ + "static/media/flag_square_ru.08290bb67906859a7665cd76b71bf170.svg";
export { ForwardRef as ReactComponent };